type NamedResident =
  | { firstname: string; lastname: string }
  | { firstName: string; lastName: string };

const names = (r: NamedResident): [string, string] =>
  'lastname' in r ? [r.lastname, r.firstname] : [r.lastName, r.firstName];

export const compareResidentsByName = (
  a: NamedResident,
  b: NamedResident
): number => {
  const [aLast, aFirst] = names(a);
  const [bLast, bFirst] = names(b);
  return aLast.localeCompare(bLast) || aFirst.localeCompare(bFirst);
};
